import React, { createContext, useEffect } from "react";
import { usePageConfigurationQuery } from "@common-vendors/generated/graphql";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var pageConfigInitialState = {};
export var PageConfigurationContext = /*#__PURE__*/createContext({
  data: pageConfigInitialState,
  loading: false
});
export var PageConfigurationContextProvider = function PageConfigurationContextProvider(_ref) {
  var _data$cmsConfiguratio;

  var children = _ref.children;

  var _usePageConfiguration = usePageConfigurationQuery(),
      data = _usePageConfiguration.data,
      loading = _usePageConfiguration.loading,
      refetch = _usePageConfiguration.refetch;

  var pageConfigData = !(data !== null && data !== void 0 && (_data$cmsConfiguratio = data.cmsConfiguration) !== null && _data$cmsConfiguratio !== void 0 && _data$cmsConfiguratio.page) ? pageConfigInitialState : data.cmsConfiguration.page;
  useEffect(function () {
    var mounted = true;

    if (mounted) {
      refetch();
    }

    return function () {
      mounted = false;
    };
  }, [refetch]);
  return ___EmotionJSX(PageConfigurationContext.Provider, {
    value: {
      data: pageConfigData,
      loading: loading
    }
  }, children);
};